import React, { Component } from 'react';
import Link from 'gatsby-link';
import styled from 'styled-components';
import { observer, inject } from 'mobx-react';

import allData from '../data/data.json';

import { Container, Row, Column } from '../components/global/grid/grid';
import PageBuilder from '../components/pagebuilder/pagebuilder';
import MapHero from '../components/modules/MapHero/MapHero'
import HomeHero from '../components/modules/HomeHero/HomeHero';

import RepeatingElements from '../components/RepeatingElements/RepeatingElements';

@inject("store")
@observer
class IndexPage extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    const { store } = this.props;
    store.setCSPage(false);
  }
  render() {
    const { store, imageDictionary, videoDictionary } = this.props;
    return (
      <div>
        <RepeatingElements stamps={allData.stamps}/>
        <MapHero data={allData.home.campaignIntro} />
        <Container style={{position: 'relative'}}>
          <Row margins={false}>
            <Column>
              <HomeHero data={allData.home.hero} />
            </Column>
          </Row>
          <PageBuilder modules={allData.home.modules} imageDictionary={imageDictionary} videoDictionary={videoDictionary} />
        </Container>
      </div>
    )
  }
}

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js